import Globals from '../globals';
import Object from "./object.ts";
class Platform extends Object {
    constructor(pos, world) {
        let tileIndex = world ? 9 : 8; // Different tiles for platform on both worlds
        super(pos, tileIndex, world, 69);
        this.walkable = true;
        this.mass = 0; // Not affected by gravity
    }
    collideWithObject(object) {
        // If we collide with the player
        if (object === Globals.player) {
            // We disable the collision when he is going up to jump through
            // 0.01 for rounding errors
            if (object.velocity.y > 0) {
                return false;
            }
        }
        // Normal collision otherwise
        return super.collideWithObject(object);
    }
    update() {
        super.update();
    }
    /**
     * Called by Object.update() each frame if the object is active
     */
    defaultCollision() {
        this.setCollision(true, true, false, false);
    }
}
export default Platform;
